// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2h_7V","title":"ClientInsurance_title__3GDHW","itemText":"ClientInsurance_itemText__1WjvH"};